import { helper } from "@ember/component/helper";

export const TnmClassificationCodes = {
  t: [
    "Tis",
    "T1mic",
    "T1a",
    "T1b",
    "T1c",
    "T2",
    "T3",
    "t4a",
    "T4b",
    "T4c",
    "T4d"
  ],
  nBreastCancer: [
    "pN0Sn",
    "N0",
    "pN1mic",
    "pN1a",
    "pN1b",
    "pN1c",
    "pN2a",
    "pN2b",
    "pN3a",
    "N3b",
    "N3c"
  ],
  nOthersCancer: ["Nx", "N0", "N1", "N2", "N3"],
  m: ["M0", "M1"]
};

export function tnmClassificationCodes([propagation]: string[]): Array<string> {
  switch (propagation) {
    case "t":
      return TnmClassificationCodes.t;
    case "nBreastCancer":
      return TnmClassificationCodes.nBreastCancer;
    case "nOthersCancer":
      return TnmClassificationCodes.nOthersCancer;
    case "m":
      return TnmClassificationCodes.m;
    default:
      throw `unknown propagation: ${propagation}`;
  }
}

export default helper(tnmClassificationCodes);
